<template>
  <div :class="$style.wrapper">
    <div :class="$style.inner">
      <card v-for="card in cards.user" ref="cards" class="draggable-item" v-bind="card" :key="card.title" />
      <card v-for="card in cards.cheater" ref="cards" class="draggable-item" v-bind="card" :key="card.title" />
    </div>
  </div>
</template>
<script>
import card from './card'

export default {
  name: 'cards',
  components: { card },
  props: {
    data: Array,
    drag: Boolean,
  },
  methods: {
    reset() {
      this.$refs.cards.forEach(i => i.reset())
    },
    resetCard(index) {
      this.$refs.cards[index].reset()
    },
  },
  data() {
    const { data } = this

    return {
      cards: {
        user: data.filter(i => i.type === 'user'),
        cheater: data.filter(i => i.type === 'cheater'),
      },
    }
  },
}
</script>
<style lang="scss" module>
.wrapper {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  padding: 0 2rem;
  padding-bottom: 5.4rem;
  //overflow: hidden;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  align-items: flex-end;
  transform: translateZ(20px);

  :global(.flickity-viewport) {
    overflow: visible;
  }
}
.inner {
  display: flex;
  padding-right: 20rem;
  pointer-events: auto;
}
</style>
